import { render, staticRenderFns } from "./SetNoteForBookkeeperModal.vue?vue&type=template&id=e96e4ed8&scoped=true"
import script from "./SetNoteForBookkeeperModal.vue?vue&type=script&lang=ts"
export * from "./SetNoteForBookkeeperModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96e4ed8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e96e4ed8')) {
      api.createRecord('e96e4ed8', component.options)
    } else {
      api.reload('e96e4ed8', component.options)
    }
    module.hot.accept("./SetNoteForBookkeeperModal.vue?vue&type=template&id=e96e4ed8&scoped=true", function () {
      api.rerender('e96e4ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/SetNoteForBookkeeperModal.vue"
export default component.exports